module.exports = __webpack_public_path__ + "img/from.6222ae70.png";